import { render, staticRenderFns } from "./DashboardAttachement.vue?vue&type=template&id=fd5651fa&scoped=true"
import script from "./DashboardAttachement.vue?vue&type=script&lang=js"
export * from "./DashboardAttachement.vue?vue&type=script&lang=js"
import style0 from "./DashboardAttachement.vue?vue&type=style&index=0&id=fd5651fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5651fa",
  null
  
)

export default component.exports